<template>
  <div>
    <v-row>
      <v-col class="pb-0">
        <p>
          Ao replicar a escala atual para o próximo mês,
          todos os turnos com <strong>plantonistas fixos</strong> serão replicados.
        </p>
        <p>
          Caso queira replicar os turnos com os <strong>plantonistas temporários</strong>
          que trabalharam este mês, selecione a opção abaixo.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0 pt-0">
        <v-switch
          v-model="includeTemp"
          label="Replicar plantonistas temporários"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-spacer></v-spacer>
      <v-col sm="6">
        <v-btn
          block
          color="secondary"
          outlined
          @click="close"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-col>
      <v-col sm="6">
        <v-btn
          block
          color="primary"
          @click="noop"
        >
          {{ $t('button.rejoin') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
  .empty-turns {
    margin: 3rem auto !important;
  }

  .empty-turns p {
    font-size: 0.9rem;
  }
</style>

<script>
export default {
  props: {
    close: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      includeTemp: false,
    };
  },

  methods: {
    noop() {
      return null;
    },
  },
};
</script>
